import {
    Container,
    Title,
    Text,
    SimpleGrid,
    Paper,
    Group,
} from "@mantine/core";
import {
    IconCode,
    IconServer,
    IconDatabase,
    IconSeo,
} from "@tabler/icons-react";
import { motion } from "framer-motion";
import classes from "./About.module.css";

const iconMap = {
    code: IconCode,
    server: IconServer,
    database: IconDatabase,
    seo: IconSeo,
};

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.15,
        },
    },
};

const cardVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            type: "spring",
            stiffness: 80,
            damping: 12,
        },
    },
};

export function About({ data }) {
    return (
        <section className={classes.section} id='about'>
            <Container size='lg'>
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6 }}>
                    <Title
                        order={2}
                        className={classes.title}
                        ta='center'
                        mb='xl'>
                        O mně
                    </Title>

                    <Text
                        size='lg'
                        maw={800}
                        mx='auto'
                        ta='center'
                        mb={50}
                        c='dimmed'>
                        {data.personalInfo.bio}
                    </Text>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial='hidden'
                    whileInView='visible'
                    viewport={{ once: true, amount: 0.2 }}>
                    <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing='xl'>
                        {data.services.map((service, index) => {
                            const Icon = iconMap[service.icon];
                            return (
                                <motion.div key={index} variants={cardVariants}>
                                    <Paper
                                        p='xl'
                                        radius='md'
                                        className={classes.card}>
                                        <Group justify='center' mb='md'>
                                            <div
                                                className={classes.iconWrapper}>
                                                <Icon size={32} stroke={1.5} />
                                            </div>
                                        </Group>
                                        <Title
                                            order={3}
                                            size='h4'
                                            ta='center'
                                            mb='sm'>
                                            {service.title}
                                        </Title>
                                        <Text size='sm' c='dimmed' ta='center'>
                                            {service.description}
                                        </Text>
                                    </Paper>
                                </motion.div>
                            );
                        })}
                    </SimpleGrid>
                </motion.div>
            </Container>
        </section>
    );
}
